const myAccount = {
  availableWhenAccountIsApproved: 'Disponibile quando l\'account è approvato',
  freeSanctionChecksAndPepScreenings:
    'Controlli gratuiti delle sanzioni e screening PEP',
  myAccount: 'My Account',
  requestApproved: 'La tua richiesta è stata approvata',
  requestCompleted: 'Il tuo account è attivo',
  requestPending: 'La tua richiesta è in attesa',
  requestRejected: 'La tua richiesta è stata rifiutata',
  walletAssignmentInProgress: 'Attendi, stiamo configurando i tuoi dati',
  walletCreationFailed: 'Si è verificato un errore, riprova più tardi',
  verifyAllProvidedDocuments: 'Verifica tutti i documenti forniti',
  yourOnboardingData: 'I tuoi dati di onboarding',
};

export default myAccount;
